import { CellPosition } from './types';
import { Slice } from '@teetsh/app/src/types/print';
import { Cell } from '@teetsh/app/src/containers/EmploiDuTemps/Print/types';
import { getSlicesOfTheEvent } from '@teetsh/app/src/utils/slices';

function getCorrectEventBasedOnIndex(cells: CellPosition[], index: number) {
  return cells.find(e => e.x === index);
}

// Function recursive qui permet pour une slice donnée de
// calculer les cells d'un table
export function computeCells(
  index: number,
  acc: (Cell & { toDelete?: boolean })[],
  nbOfUnitPerCell: number,
  cellPositionsOfStartingEvents: CellPosition[],
  cellPositionsOfHappeningEvents: CellPosition[],
  cellPositionsOfOtherEvents: CellPosition[],
  slices: Slice[],
): Cell[] {
  if (index >= nbOfUnitPerCell) {
    return acc.filter(e => !e.toDelete) as Cell[];
  }
  const matchingEvent = getCorrectEventBasedOnIndex(
    cellPositionsOfStartingEvents,
    index,
  );
  if (matchingEvent) {
    const rowspan = getSlicesOfTheEvent(matchingEvent.event, slices).length;
    const { event } = matchingEvent;
    const cell: Cell = {
      event,
      title: event.title,
      color: event.tag && event.tag.color,
      colspan: matchingEvent.w,
      rowspan,
    };
    return computeCells(
      index + matchingEvent.w,
      [...acc, cell],
      nbOfUnitPerCell,
      cellPositionsOfStartingEvents,
      cellPositionsOfHappeningEvents,
      cellPositionsOfOtherEvents,
      slices,
    );
  }
  const matchingEventHappeningInTheSlice = getCorrectEventBasedOnIndex(
    cellPositionsOfHappeningEvents,
    index,
  );
  if (matchingEventHappeningInTheSlice) {
    return computeCells(
      index + matchingEventHappeningInTheSlice.w,
      [...acc, { toDelete: true, rowspan: 0, colspan: 0 }],
      nbOfUnitPerCell,
      cellPositionsOfStartingEvents,
      cellPositionsOfHappeningEvents,
      cellPositionsOfOtherEvents,
      slices,
    );
  }
  const matchingEventFromOtherSlice = getCorrectEventBasedOnIndex(
    cellPositionsOfOtherEvents,
    index,
  );
  if (matchingEventFromOtherSlice) {
    const lastItem = acc.length > 0 ? acc.slice(-1)[0] : undefined;
    // Si le dernier élément de la row est vide on merge sauf si c'est un élément à supprimer,
    // car ça veut dire qu'un élément d'une autre row sera là...
    if (lastItem && !lastItem.event && !lastItem.toDelete) {
      acc.pop();
      return computeCells(
        index + 1,
        [
          ...acc,
          {
            ...lastItem,
            colspan: (lastItem.colspan ?? 0) + 1,
          },
        ],
        nbOfUnitPerCell,
        cellPositionsOfStartingEvents,
        cellPositionsOfHappeningEvents,
        cellPositionsOfOtherEvents,
        slices,
      );
    }
    return computeCells(
      index + matchingEventFromOtherSlice.w,
      [...acc, { rowspan: 1, colspan: matchingEventFromOtherSlice.w }],
      nbOfUnitPerCell,
      cellPositionsOfStartingEvents,
      cellPositionsOfHappeningEvents,
      cellPositionsOfOtherEvents,
      slices,
    );
  }
  if (acc.length === 0) {
    return computeCells(
      index + 1,
      [
        ...acc,
        {
          rowspan: 1,
          colspan: 1,
        },
      ],
      nbOfUnitPerCell,
      cellPositionsOfStartingEvents,
      cellPositionsOfHappeningEvents,
      cellPositionsOfOtherEvents,
      slices,
    );
  }

  const lastItem = acc.slice(-1)[0];
  // On merge avec l'empty cell précédente
  acc.pop();
  return computeCells(
    index + 1,
    [
      ...acc,
      {
        ...lastItem,
        colspan: (lastItem.colspan ?? 0) + 1,
        // rowspan: 1,
      },
    ],
    nbOfUnitPerCell,
    cellPositionsOfStartingEvents,
    cellPositionsOfHappeningEvents,
    cellPositionsOfOtherEvents,
    slices,
  );
}
